import { useMemo } from "react";

import { useGetReferralSourcesQuery } from "services/referral-sources";

type SelectedReferralSource = {
  id: number | string;
  name: string;
  is_active?: boolean;
};

export default function useReferralSourceOptions(
  selectedValue?: SelectedReferralSource | null
) {
  const { data: referralSources } = useGetReferralSourcesQuery({
    is_active: true
  });

  const referralSourceOptions = useMemo(() => {
    const options =
      referralSources?.map(({ id, name }) => ({
        value: String(id),
        label: name
      })) ?? [];

    if (selectedValue?.id) {
      const selectedId = String(selectedValue.id);
      const alreadyInList = options.some((o) => o.value === selectedId);
      if (!alreadyInList) {
        options.push({
          value: selectedId,
          label:
            selectedValue.is_active === false
              ? `${selectedValue.name} (Inactive)`
              : selectedValue.name
        });
      }
    }

    return options;
  }, [referralSources, selectedValue]);

  return referralSourceOptions;
}
